"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e, jsxs as l, Fragment as We } from "react/jsx-runtime";
import * as b from "react";
import _e from "./tag.js";
import ne from "./stack.js";
import P from "./box.js";
import { Text as ie, textProps as oe, Text2 as D, Text6 as $e, Text3 as qe } from "./text.js";
import { Boxed as he, InternalBoxed as be } from "./boxed.js";
import ue from "./button-group.js";
import pe from "./image.js";
import { BaseTouchable as _ } from "./touchable.js";
import { vars as p } from "./skins/skin-contract.css-mistica.js";
import { cardContainer as Je, touchableContainer as $, boxed as Q, touchable as q, touchableMediaCardOverlay as Ke, mediaCard as fe, mediaCardContent as Qe, mediaCardIcon as Ce, touchableNakedMediaOverlay as Te, circularMediaOverlay as Ne, nakedCardContent as Be, touchableCardOverlay as de, dataCard as Ue, vars as Re, dataCardTopActionsWithoutIcon as Ye, actions as ke, snapCard as Ze, displayCardContainer as Ie, displayCardBackground as we, displayCardContent as Se, displayCardGradient as Ae, flexColumn as Me, touchableCardOverlayInverse as ve, touchableCardOverlayMedia as De } from "./card.css-mistica.js";
import { vars as W } from "./image.css-mistica.js";
import { useTheme as K } from "./hooks.js";
import { sprinkles as ea } from "./sprinkles.css-mistica.js";
import { InternalIconButton as aa, InternalToggleIconButton as ra } from "./icon-button.js";
import ta from "./generated/mistica-icons/icon-close-regular.js";
import na from "./generated/mistica-icons/icon-pause-filled.js";
import ia from "./generated/mistica-icons/icon-play-filled.js";
import { combineRefs as oa } from "./utils/common.js";
import da from "./spinner.js";
import sa from "./video.js";
import { ThemeVariant as ye, useIsInverseVariant as Oe } from "./theme-variant-context.js";
import ge from "classnames";
import ze from "./inline.js";
import { getPrefixedDataAttributes as la } from "./utils/dom.js";
import { isRunningAcceptanceTest as ca } from "./utils/platform.js";
import { applyCssVars as H } from "./utils/css.js";
const A = ()=>{
    const [a, r] = b.useState(""), t = b.useCallback((i)=>{
        i && r((process.env.NODE_ENV === "test" ? i.textContent : i.innerText) || "");
    }, []);
    return {
        text: a,
        ref: t
    };
}, je = (a, r, t)=>{
    const { texts: i } = K(), n = a ? [
        ...a
    ] : [];
    return r && n.push({
        label: t !== null && t !== void 0 ? t : i.closeButtonLabel,
        onPress: r,
        Icon: ta
    }), n;
}, Pe = /*#__PURE__*/ b.createContext("default"), ma = (a)=>{
    const r = b.useContext(Pe);
    return /* @__PURE__ */ e(ye, {
        isInverse: r === "inverse",
        children: a.Icon ? /* @__PURE__ */ e(aa, _object_spread_props(_object_spread({}, a), {
            "aria-label": a.label,
            small: !0,
            isOverMedia: r === "media",
            type: "neutral",
            backgroundType: "transparent"
        })) : /* @__PURE__ */ e(ra, _object_spread_props(_object_spread({}, a), {
            checkedProps: _object_spread_props(_object_spread({}, a.checkedProps), {
                "aria-label": a.checkedProps.label,
                type: r === "media" ? "neutral" : "brand",
                backgroundType: "solid"
            }),
            uncheckedProps: _object_spread_props(_object_spread({}, a.uncheckedProps), {
                "aria-label": a.uncheckedProps.label,
                type: "neutral",
                backgroundType: "transparent"
            }),
            small: !0,
            isOverMedia: r === "media"
        }))
    });
}, U = (param)=>{
    let { actions: a, padding: r = 16, onClose: t, type: i = "default", closeButtonLabel: n } = param;
    const o = je(a, t, n);
    return o.length > 0 ? /* @__PURE__ */ e(Pe.Provider, {
        value: i,
        children: /* @__PURE__ */ e("div", {
            style: {
                position: "absolute",
                right: r,
                top: r,
                zIndex: 3
            },
            children: /* @__PURE__ */ e(ze, {
                space: 16,
                children: o.map((d, f)=>"Icon" in d || "checkedProps" in d ? /* @__PURE__ */ e(ma, _object_spread({}, d), f) : d)
            })
        })
    }) : /* @__PURE__ */ e(We, {});
}, ha = (a)=>a ? typeof a == "number" ? a : ({
        "1:1": 1,
        "16:9": 16 / 9,
        "7:10": 7 / 10,
        "9:10": 9 / 10,
        auto: 0
    })[a] : 0, J = /*#__PURE__*/ b.forwardRef((param, d)=>{
    let { children: a, width: r, height: t, aspectRatio: i, dataAttributes: n, className: o, "aria-label": s } = param;
    const f = r && t ? void 0 : ha(i);
    return /* @__PURE__ */ e("section", _object_spread_props(_object_spread({}, la(n)), {
        ref: d,
        "aria-label": s,
        className: ge(o, Je),
        style: _object_spread({
            width: r || "100%",
            height: t || "100%"
        }, f ? H({
            [Re.aspectRatio]: String(f)
        }) : {}),
        children: a
    }));
}), Ve = (a)=>/* @__PURE__ */ e(pe, {
        width: "100%",
        height: "100%",
        src: a || ""
    }), ua = {
    loading: {
        showSpinner: "loadingTimeout",
        play: "playing",
        pause: "paused",
        fail: "error"
    },
    loadingTimeout: {
        play: "playing",
        pause: "paused",
        fail: "error",
        reset: "loading"
    },
    playing: {
        pause: "paused",
        reset: "loading",
        fail: "error"
    },
    paused: {
        play: "playing",
        reset: "loading",
        fail: "error"
    },
    error: {
        reset: "loading"
    }
}, pa = (a, r)=>ua[a][r] || a, fa = (param)=>{
    let { color: a } = param;
    return /* @__PURE__ */ e(da, {
        color: a,
        size: 16,
        delay: "0"
    });
}, va = (param)=>{
    let { color: a } = param;
    return /* @__PURE__ */ e(na, {
        color: a,
        size: 12
    });
}, ya = (param)=>{
    let { color: a } = param;
    return /* @__PURE__ */ e(ia, {
        color: a,
        size: 12
    });
}, Ee = (a, r, t)=>{
    const { texts: i } = K(), n = b.useRef(null), [o, s] = b.useReducer(pa, "loading");
    b.useEffect(()=>{
        var u;
        const c = setTimeout(()=>s("showSpinner"), 2e3);
        return (u = n.current) == null || u.load(), ()=>{
            clearTimeout(c), s("reset");
        };
    }, [
        a
    ]);
    const d = b.useMemo(()=>a !== void 0 ? /* @__PURE__ */ e(sa, {
            ref: oa(n, t),
            src: a,
            width: "100%",
            height: "100%",
            poster: r,
            onError: ()=>s("fail"),
            onPause: ()=>s("pause"),
            onPlay: ()=>s("play")
        }) : void 0, [
        t,
        a,
        r
    ]), f = ()=>{
        const c = n.current;
        c && (o === "loading" ? s("showSpinner") : o === "paused" ? c.play() : o === "playing" && c.pause());
    };
    if (o === "error") return {
        video: d
    };
    const h = d ? {
        uncheckedProps: {
            Icon: o === "loadingTimeout" && !ca() ? fa : va,
            label: o === "loadingTimeout" ? "" : i.pauseIconButtonLabel
        },
        checkedProps: {
            Icon: ya,
            label: i.playIconButtonLabel
        },
        onChange: f,
        disabled: o === "loadingTimeout",
        checked: o === "paused"
    } : void 0;
    return {
        video: d,
        videoAction: h
    };
}, xe = (param)=>{
    let { headline: a, headlineRef: r, pretitle: t, pretitleLinesMax: i, title: n, titleAs: o = "h3", titleLinesMax: s, subtitle: d, subtitleLinesMax: f, description: h, descriptionLinesMax: c, extra: u, extraRef: g, button: m, buttonLink: C } = param;
    const { textPresets: x } = K();
    return /* @__PURE__ */ l("div", {
        className: ea({
            display: "flex",
            flex: 1,
            justifyContent: "space-between",
            flexDirection: "column"
        }),
        children: [
            /* @__PURE__ */ l("div", {
                className: Me,
                children: [
                    n && /* @__PURE__ */ e("div", {
                        style: {
                            paddingBottom: d || h ? 4 : 0
                        },
                        children: /* @__PURE__ */ e(ie, _object_spread_props(_object_spread({}, oe.text4), {
                            truncate: s,
                            weight: x.cardTitle.weight,
                            as: o,
                            hyphens: "auto",
                            children: n
                        }))
                    }),
                    a && // assuming that the headline will always be followed by one of: pretitle, title, subtitle, description
                    /* @__PURE__ */ e("div", {
                        ref: r,
                        style: {
                            order: -2,
                            paddingBottom: 8
                        },
                        children: typeof a == "string" ? /* @__PURE__ */ e(_e, {
                            type: "promo",
                            children: a
                        }) : a
                    }),
                    t && /* @__PURE__ */ e("div", {
                        style: {
                            order: -1,
                            paddingBottom: 4
                        },
                        children: /* @__PURE__ */ e(D, {
                            truncate: i,
                            as: "div",
                            regular: !0,
                            hyphens: "auto",
                            children: t
                        })
                    }),
                    d && /* @__PURE__ */ e("div", {
                        style: {
                            paddingBottom: h ? 4 : 0
                        },
                        children: /* @__PURE__ */ e(D, {
                            truncate: f,
                            as: "div",
                            regular: !0,
                            hyphens: "auto",
                            children: d
                        })
                    }),
                    h && // this is tricky, when headline exists, the 8px padding is added by it.
                    // Otherwise, only 4px are added by title|pretitle|subtitle, so we need to add 4px more
                    /* @__PURE__ */ e("div", {
                        style: {
                            paddingTop: t || n || d ? 4 : 0
                        },
                        children: /* @__PURE__ */ e(D, {
                            truncate: c,
                            as: "p",
                            regular: !0,
                            color: p.colors.textSecondary,
                            hyphens: "auto",
                            children: h
                        })
                    }),
                    u && /* @__PURE__ */ e("div", {
                        ref: g,
                        children: u
                    })
                ]
            }),
            (m || C) && /* @__PURE__ */ e("div", {
                className: ke,
                children: /* @__PURE__ */ e(ue, {
                    primaryButton: m,
                    link: C
                })
            })
        ]
    });
}, _a = /*#__PURE__*/ b.forwardRef((_param, V)=>{
    var { media: a, icon: r, headline: t, pretitle: i, pretitleLinesMax: n, subtitle: o, subtitleLinesMax: s, title: d, titleAs: f = "h3", titleLinesMax: h, description: c, descriptionLinesMax: u, extra: g, actions: m, button: C, buttonLink: x, dataAttributes: T, "aria-label": y, onClose: k, closeButtonLabel: B } = _param, v = _object_without_properties(_param, [
        "media",
        "icon",
        "headline",
        "pretitle",
        "pretitleLinesMax",
        "subtitle",
        "subtitleLinesMax",
        "title",
        "titleAs",
        "titleLinesMax",
        "description",
        "descriptionLinesMax",
        "extra",
        "actions",
        "button",
        "buttonLink",
        "dataAttributes",
        "aria-label",
        "onClose",
        "closeButtonLabel"
    ]);
    const N = !!(v.href || v.to || v.onPress), { text: M, ref: E } = A(), { text: O, ref: w } = A(), z = y || [
        d,
        M,
        i,
        o,
        c,
        O
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ l(J, {
        dataAttributes: _object_spread({
            "component-name": "MediaCard"
        }, T),
        ref: V,
        "aria-label": N ? void 0 : y,
        className: $,
        children: [
            /* @__PURE__ */ e(he, {
                className: Q,
                width: "100%",
                height: "100%",
                children: /* @__PURE__ */ l(_, _object_spread_props(_object_spread({
                    maybe: !0
                }, v), {
                    className: q,
                    "aria-label": N ? z : void 0,
                    children: [
                        N && /* @__PURE__ */ e("div", {
                            className: Ke
                        }),
                        /* @__PURE__ */ l("div", {
                            className: fe,
                            children: [
                                /* @__PURE__ */ e("div", {
                                    style: H({
                                        [W.mediaBorderRadius]: "0px"
                                    }),
                                    children: a
                                }),
                                /* @__PURE__ */ e("div", {
                                    className: Qe,
                                    children: /* @__PURE__ */ e(xe, {
                                        headline: t,
                                        headlineRef: E,
                                        pretitle: i,
                                        pretitleLinesMax: n,
                                        title: d,
                                        titleAs: f,
                                        titleLinesMax: h,
                                        subtitle: o,
                                        subtitleLinesMax: s,
                                        description: c,
                                        descriptionLinesMax: u,
                                        extra: g,
                                        extraRef: w,
                                        button: C,
                                        buttonLink: x
                                    })
                                }),
                                r && /* @__PURE__ */ e(P, {
                                    className: Ce,
                                    paddingLeft: {
                                        mobile: 16,
                                        desktop: 24
                                    },
                                    paddingTop: {
                                        mobile: 16,
                                        desktop: 24
                                    },
                                    children: /* @__PURE__ */ e("div", {
                                        style: H({
                                            [W.mediaBorderRadius]: p.borderRadii.mediaSmall
                                        }),
                                        children: r
                                    })
                                })
                            ]
                        })
                    ]
                }))
            }),
            /* @__PURE__ */ e(U, {
                onClose: k,
                closeButtonLabel: B,
                actions: m,
                type: "media"
            })
        ]
    });
}), $a = /*#__PURE__*/ b.forwardRef((_param, V)=>{
    var { media: a, icon: r, headline: t, pretitle: i, pretitleLinesMax: n, subtitle: o, subtitleLinesMax: s, title: d, titleAs: f = "h3", titleLinesMax: h, description: c, descriptionLinesMax: u, extra: g, actions: m, button: C, buttonLink: x, dataAttributes: T, "aria-label": y, onClose: k, closeButtonLabel: B } = _param, v = _object_without_properties(_param, [
        "media",
        "icon",
        "headline",
        "pretitle",
        "pretitleLinesMax",
        "subtitle",
        "subtitleLinesMax",
        "title",
        "titleAs",
        "titleLinesMax",
        "description",
        "descriptionLinesMax",
        "extra",
        "actions",
        "button",
        "buttonLink",
        "dataAttributes",
        "aria-label",
        "onClose",
        "closeButtonLabel"
    ]);
    const N = !!(v.href || v.to || v.onPress), M = a && a.type === pe && a.props.circular, { text: E, ref: O } = A(), { text: w, ref: z } = A(), R = y || [
        d,
        E,
        i,
        o,
        c,
        w
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ l(J, {
        ref: V,
        dataAttributes: _object_spread({
            "component-name": "NakedCard"
        }, T),
        "aria-label": N ? void 0 : y,
        className: N ? $ : void 0,
        children: [
            /* @__PURE__ */ e(_, _object_spread_props(_object_spread({
                maybe: !0
            }, v), {
                className: q,
                "aria-label": N ? R : void 0,
                children: /* @__PURE__ */ l("div", {
                    className: fe,
                    children: [
                        /* @__PURE__ */ l("div", {
                            style: {
                                position: "relative"
                            },
                            children: [
                                N && /* @__PURE__ */ e("div", {
                                    className: ge(Te, {
                                        [Ne]: M
                                    })
                                }),
                                a
                            ]
                        }),
                        /* @__PURE__ */ e("div", {
                            className: Be,
                            children: /* @__PURE__ */ e(xe, {
                                headline: t,
                                headlineRef: O,
                                pretitle: i,
                                pretitleLinesMax: n,
                                title: d,
                                titleAs: f,
                                titleLinesMax: h,
                                subtitle: o,
                                subtitleLinesMax: s,
                                description: c,
                                descriptionLinesMax: u,
                                extra: g,
                                extraRef: z,
                                button: C,
                                buttonLink: x
                            })
                        }),
                        r && /* @__PURE__ */ e(P, {
                            className: Ce,
                            paddingLeft: {
                                mobile: 16,
                                desktop: 24
                            },
                            paddingTop: {
                                mobile: 16,
                                desktop: 24
                            },
                            children: /* @__PURE__ */ e("div", {
                                style: H({
                                    [W.mediaBorderRadius]: p.borderRadii.mediaSmall
                                }),
                                children: r
                            })
                        })
                    ]
                })
            })),
            /* @__PURE__ */ e(U, {
                onClose: k,
                closeButtonLabel: B,
                actions: m,
                type: "media"
            })
        ]
    });
}), qa = /*#__PURE__*/ b.forwardRef((_param, g)=>{
    var { media: a, title: r, titleAs: t = "h3", titleLinesMax: i, subtitle: n, subtitleLinesMax: o, description: s, descriptionLinesMax: d, extra: f, dataAttributes: h, "aria-label": c } = _param, u = _object_without_properties(_param, [
        "media",
        "title",
        "titleAs",
        "titleLinesMax",
        "subtitle",
        "subtitleLinesMax",
        "description",
        "descriptionLinesMax",
        "extra",
        "dataAttributes",
        "aria-label"
    ]);
    const m = !!(u.href || u.to || u.onPress), C = a && a.type === pe && a.props.circular, { textPresets: x } = K(), { text: T, ref: y } = A(), k = c || [
        r,
        n,
        s,
        T
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ e(J, {
        ref: g,
        dataAttributes: _object_spread({
            "component-name": "SmallNakedCard"
        }, h),
        "aria-label": m ? void 0 : c,
        className: m ? $ : void 0,
        children: /* @__PURE__ */ e(_, _object_spread_props(_object_spread({
            maybe: !0
        }, u), {
            className: q,
            "aria-label": m ? k : void 0,
            children: /* @__PURE__ */ l("div", {
                className: fe,
                children: [
                    /* @__PURE__ */ l("div", {
                        style: {
                            position: "relative"
                        },
                        children: [
                            m && /* @__PURE__ */ e("div", {
                                className: ge(Te, {
                                    [Ne]: C
                                })
                            }),
                            a
                        ]
                    }),
                    /* @__PURE__ */ l("div", {
                        className: Be,
                        children: [
                            /* @__PURE__ */ e("div", {
                                children: /* @__PURE__ */ l(ne, {
                                    space: 4,
                                    children: [
                                        r && /* @__PURE__ */ e(ie, _object_spread_props(_object_spread({}, oe.text2), {
                                            truncate: i,
                                            weight: x.cardTitle.weight,
                                            as: t,
                                            hyphens: "auto",
                                            children: r
                                        })),
                                        n && /* @__PURE__ */ e(D, {
                                            truncate: o,
                                            regular: !0,
                                            as: "p",
                                            hyphens: "auto",
                                            children: n
                                        }),
                                        s && /* @__PURE__ */ e(D, {
                                            truncate: d,
                                            regular: !0,
                                            as: "p",
                                            color: p.colors.textSecondary,
                                            hyphens: "auto",
                                            children: s
                                        })
                                    ]
                                })
                            }),
                            f && /* @__PURE__ */ e("div", {
                                ref: y,
                                children: f
                            })
                        ]
                    })
                ]
            })
        }))
    });
}), Ja = /*#__PURE__*/ b.forwardRef((_param, V)=>{
    var { icon: a, headline: r, pretitle: t, pretitleLinesMax: i, title: n, titleAs: o = "h3", titleLinesMax: s, subtitle: d, subtitleLinesMax: f, description: h, descriptionLinesMax: c, extra: u, actions: g, button: m, buttonLink: C, dataAttributes: x, "aria-label": T, onClose: y, closeButtonLabel: k, aspectRatio: B } = _param, v = _object_without_properties(_param, [
        "icon",
        "headline",
        "pretitle",
        "pretitleLinesMax",
        "title",
        "titleAs",
        "titleLinesMax",
        "subtitle",
        "subtitleLinesMax",
        "description",
        "descriptionLinesMax",
        "extra",
        "actions",
        "button",
        "buttonLink",
        "dataAttributes",
        "aria-label",
        "onClose",
        "closeButtonLabel",
        "aspectRatio"
    ]);
    const N = !!a || !!r, M = !!(v.href || v.to || v.onPress), { text: E, ref: O } = A(), { text: w, ref: z } = A(), R = je(g, y), I = T || [
        n,
        E,
        t,
        h,
        w
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ l(J, {
        dataAttributes: _object_spread({
            "component-name": "DataCard"
        }, x),
        ref: V,
        "aria-label": M ? void 0 : T,
        className: $,
        aspectRatio: B,
        children: [
            /* @__PURE__ */ e(he, {
                className: Q,
                width: "100%",
                minHeight: "100%",
                children: /* @__PURE__ */ l(_, _object_spread_props(_object_spread({
                    maybe: !0
                }, v), {
                    className: q,
                    "aria-label": M ? I : void 0,
                    children: [
                        M && /* @__PURE__ */ e("div", {
                            className: de
                        }),
                        /* @__PURE__ */ l("div", {
                            className: Ue,
                            children: [
                                /* @__PURE__ */ l(ze, {
                                    space: 0,
                                    children: [
                                        /* @__PURE__ */ l(ne, {
                                            space: 16,
                                            children: [
                                                a && /* @__PURE__ */ e("div", {
                                                    style: H({
                                                        [W.mediaBorderRadius]: p.borderRadii.mediaSmall
                                                    }),
                                                    children: a
                                                }),
                                                /* @__PURE__ */ e(xe, {
                                                    headline: r,
                                                    headlineRef: O,
                                                    pretitle: t,
                                                    pretitleLinesMax: i,
                                                    title: n,
                                                    titleAs: o,
                                                    titleLinesMax: s,
                                                    subtitle: d,
                                                    subtitleLinesMax: f,
                                                    description: h,
                                                    descriptionLinesMax: c
                                                })
                                            ]
                                        }),
                                        !N && /* @__PURE__ */ e("div", {
                                            style: H({
                                                [Re.topActionsCount]: String(R.length)
                                            }),
                                            className: Ye
                                        })
                                    ]
                                }),
                                u && /* @__PURE__ */ e("div", {
                                    ref: z,
                                    children: u
                                }),
                                (m || C) && /* @__PURE__ */ e("div", {
                                    className: ke,
                                    children: /* @__PURE__ */ e(ue, {
                                        primaryButton: m,
                                        link: C
                                    })
                                })
                            ]
                        })
                    ]
                }))
            }),
            /* @__PURE__ */ e(U, {
                onClose: y,
                closeButtonLabel: k,
                actions: g,
                type: "default"
            })
        ]
    });
}), Ka = /*#__PURE__*/ b.forwardRef((_param, C)=>{
    var { icon: a, title: r, titleAs: t = "h3", titleLinesMax: i, subtitle: n, subtitleLinesMax: o, description: s, descriptionLinesMax: d, dataAttributes: f, "aria-label": h, extra: c, isInverse: u = !1, aspectRatio: g } = _param, m = _object_without_properties(_param, [
        "icon",
        "title",
        "titleAs",
        "titleLinesMax",
        "subtitle",
        "subtitleLinesMax",
        "description",
        "descriptionLinesMax",
        "dataAttributes",
        "aria-label",
        "extra",
        "isInverse",
        "aspectRatio"
    ]);
    const { textPresets: x } = K(), T = !!(m.href || m.to || m.onPress), y = u ? ve : de, { text: k, ref: B } = A(), v = h || [
        r,
        n,
        s,
        k
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ e(J, {
        dataAttributes: _object_spread({
            "component-name": "SnapCard"
        }, f),
        ref: C,
        className: $,
        aspectRatio: g,
        "aria-label": T ? void 0 : h,
        children: /* @__PURE__ */ e(he, {
            className: Q,
            isInverse: u,
            width: "100%",
            minHeight: "100%",
            children: /* @__PURE__ */ l(_, _object_spread_props(_object_spread({
                maybe: !0
            }, m), {
                className: q,
                "aria-label": T ? v : void 0,
                children: [
                    T && /* @__PURE__ */ e("div", {
                        className: y
                    }),
                    /* @__PURE__ */ l("section", {
                        className: Ze,
                        children: [
                            /* @__PURE__ */ l("div", {
                                children: [
                                    a && /* @__PURE__ */ e("div", {
                                        style: H({
                                            [W.mediaBorderRadius]: p.borderRadii.mediaSmall
                                        }),
                                        children: /* @__PURE__ */ e(P, {
                                            paddingBottom: 16,
                                            children: a
                                        })
                                    }),
                                    /* @__PURE__ */ l(ne, {
                                        space: 4,
                                        children: [
                                            r && /* @__PURE__ */ e(ie, _object_spread_props(_object_spread({}, oe.text2), {
                                                truncate: i,
                                                weight: x.cardTitle.weight,
                                                as: t,
                                                hyphens: "auto",
                                                children: r
                                            })),
                                            n && /* @__PURE__ */ e(D, {
                                                truncate: o,
                                                regular: !0,
                                                color: p.colors.textPrimary,
                                                as: "p",
                                                hyphens: "auto",
                                                children: n
                                            }),
                                            s && /* @__PURE__ */ e(D, {
                                                truncate: d,
                                                regular: !0,
                                                color: p.colors.textSecondary,
                                                as: "p",
                                                hyphens: "auto",
                                                children: s
                                            })
                                        ]
                                    })
                                ]
                            }),
                            c && /* @__PURE__ */ e("div", {
                                ref: B,
                                children: c
                            })
                        ]
                    })
                ]
            }))
        })
    });
}), Ge = (param)=>{
    let { title: a, headline: r, pretitle: t, subtitle: i, description: n, extra: o, headlineRef: s, extraRef: d } = param;
    return /* @__PURE__ */ l("div", {
        className: Me,
        children: [
            a && /* @__PURE__ */ e("div", {
                style: {
                    paddingBottom: i || n ? 4 : 0
                },
                children: a
            }),
            r && // assuming that the headline will always be followed by one of: pretitle, title, subtitle, description
            /* @__PURE__ */ e("div", {
                ref: s,
                style: {
                    order: -2,
                    paddingBottom: 16
                },
                children: r
            }),
            t && /* @__PURE__ */ e("div", {
                style: {
                    order: -1,
                    paddingBottom: 4
                },
                children: t
            }),
            i && /* @__PURE__ */ e("div", {
                style: {
                    paddingBottom: i ? 4 : 0
                },
                children: i
            }),
            n && // this is tricky, the padding between a headline and a description is 16px
            // but the padding between a title|pretitle|subtitle and a description is 8px (4px + 4px)
            /* @__PURE__ */ e("div", {
                style: {
                    paddingTop: t || a || i ? 4 : 0
                },
                children: n
            }),
            o && /* @__PURE__ */ e("div", {
                ref: d,
                children: o
            })
        ]
    });
}, He = /*#__PURE__*/ b.forwardRef((_param, z)=>{
    var { isInverse: a, backgroundImage: r, backgroundVideo: t, backgroundVideoRef: i, poster: n, icon: o, headline: s, pretitle: d, pretitleLinesMax: f, title: h, titleAs: c = "h3", titleLinesMax: u, description: g, descriptionLinesMax: m, extra: C, button: x, secondaryButton: T, onClose: y, closeButtonLabel: k, actions: B, buttonLink: v, dataAttributes: V, width: N, height: M, aspectRatio: E, "aria-label": O } = _param, w = _object_without_properties(_param, [
        "isInverse",
        "backgroundImage",
        "backgroundVideo",
        "backgroundVideoRef",
        "poster",
        "icon",
        "headline",
        "pretitle",
        "pretitleLinesMax",
        "title",
        "titleAs",
        "titleLinesMax",
        "description",
        "descriptionLinesMax",
        "extra",
        "button",
        "secondaryButton",
        "onClose",
        "closeButtonLabel",
        "actions",
        "buttonLink",
        "dataAttributes",
        "width",
        "height",
        "aspectRatio",
        "aria-label"
    ]);
    const R = r !== void 0, I = t !== void 0, X = Ve(r), { video: S, videoAction: Y } = Ee(t, n, i), { text: se, ref: Z } = A(), { text: le, ref: ce } = A();
    I && (B = Y ? [
        Y
    ] : []);
    const ee = Oe(), G = R || I, F = G ? "0 0 16px rgba(0,0,0,0.4)" : void 0, j = (B == null ? void 0 : B.length) || y, L = !!(w.href || w.to || w.onPress), ae = R || I ? De : a ? ve : de, me = O || [
        h,
        se,
        d,
        g,
        le
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ l(J, {
        dataAttributes: V,
        ref: z,
        width: N,
        height: M,
        aspectRatio: E,
        "aria-label": L ? void 0 : O,
        className: $,
        children: [
            /* @__PURE__ */ e(be, {
                borderRadius: p.borderRadii.legacyDisplay,
                className: Q,
                width: "100%",
                minHeight: "100%",
                isInverse: a,
                background: R || I ? ee ? p.colors.backgroundContainerBrandOverInverse : p.colors.backgroundContainer : void 0,
                children: /* @__PURE__ */ l(_, _object_spread_props(_object_spread({
                    maybe: !0
                }, w), {
                    className: q,
                    "aria-label": L ? me : void 0,
                    children: [
                        L && /* @__PURE__ */ e("div", {
                            className: ae
                        }),
                        /* @__PURE__ */ l("div", {
                            className: Ie,
                            children: [
                                (R || I) && /* @__PURE__ */ e(ye, {
                                    isInverse: ee,
                                    children: /* @__PURE__ */ e("div", {
                                        className: we,
                                        children: I ? S : X
                                    })
                                }),
                                /* @__PURE__ */ l("div", {
                                    className: Se,
                                    style: {
                                        paddingTop: G && !o && !j && !I ? 0 : 24
                                    },
                                    children: [
                                        o ? /* @__PURE__ */ e("div", {
                                            style: H({
                                                [W.mediaBorderRadius]: p.borderRadii.mediaSmall
                                            }),
                                            children: /* @__PURE__ */ e(P, {
                                                paddingBottom: G ? 0 : 40,
                                                paddingX: 24,
                                                children: o
                                            })
                                        }) : /* @__PURE__ */ e(P, {
                                            paddingBottom: j || I ? G ? 24 : 64 : 0
                                        }),
                                        /* @__PURE__ */ e(P, {
                                            paddingX: 24,
                                            paddingTop: G ? 40 : 0,
                                            paddingBottom: 24,
                                            className: G ? Ae : void 0,
                                            children: /* @__PURE__ */ l(ne, {
                                                space: 24,
                                                children: [
                                                    /* @__PURE__ */ e(Ge, {
                                                        title: h ? /* @__PURE__ */ e($e, {
                                                            forceMobileSizes: !0,
                                                            truncate: u,
                                                            as: c,
                                                            textShadow: F,
                                                            hyphens: "auto",
                                                            children: h
                                                        }) : void 0,
                                                        headline: s,
                                                        pretitle: d ? /* @__PURE__ */ e(D, {
                                                            forceMobileSizes: !0,
                                                            truncate: f,
                                                            as: "div",
                                                            regular: !0,
                                                            textShadow: F,
                                                            children: d
                                                        }) : void 0,
                                                        description: g ? /* @__PURE__ */ e(qe, {
                                                            forceMobileSizes: !0,
                                                            truncate: m,
                                                            as: "p",
                                                            regular: !0,
                                                            color: G ? p.colors.textPrimary : p.colors.textSecondary,
                                                            textShadow: F,
                                                            hyphens: "auto",
                                                            children: g
                                                        }) : void 0,
                                                        extra: C,
                                                        headlineRef: Z,
                                                        extraRef: ce
                                                    }),
                                                    (x || T || v) && /* @__PURE__ */ e(ue, {
                                                        primaryButton: x,
                                                        secondaryButton: T,
                                                        link: v
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }))
            }),
            /* @__PURE__ */ e(U, {
                onClose: y,
                closeButtonLabel: k,
                actions: B,
                type: R || I ? "media" : a ? "inverse" : "default"
            })
        ]
    });
}), Qa = /*#__PURE__*/ b.forwardRef((_param, t)=>{
    var { dataAttributes: a } = _param, r = _object_without_properties(_param, [
        "dataAttributes"
    ]);
    return /* @__PURE__ */ e(He, _object_spread_props(_object_spread({}, r), {
        ref: t,
        isInverse: !0,
        dataAttributes: _object_spread({
            "component-name": "DisplayMediaCard"
        }, a)
    }));
}), Ua = /*#__PURE__*/ b.forwardRef((_param, t)=>{
    var { dataAttributes: a } = _param, r = _object_without_properties(_param, [
        "dataAttributes"
    ]);
    return /* @__PURE__ */ e(He, _object_spread_props(_object_spread({}, r), {
        ref: t,
        dataAttributes: _object_spread({
            "component-name": "DisplayDataCard"
        }, a)
    }));
}), Ya = /*#__PURE__*/ b.forwardRef((_param, I)=>{
    var { dataAttributes: a, backgroundImage: r, backgroundVideo: t, poster: i, backgroundVideoRef: n, width: o, height: s, aspectRatio: d = "7:10", ariaLabel: f, ["aria-label"]: h = f, actions: c, onClose: u, closeButtonLabel: g, icon: m, headline: C, pretitle: x, pretitleLinesMax: T, title: y, titleAs: k = "h3", titleLinesMax: B, subtitle: v, subtitleLinesMax: V, description: N, descriptionLinesMax: M, extra: E, variant: O, isInverse: w, backgroundColor: z } = _param, R = _object_without_properties(_param, [
        "dataAttributes",
        "backgroundImage",
        "backgroundVideo",
        "poster",
        "backgroundVideoRef",
        "width",
        "height",
        "aspectRatio",
        "ariaLabel",
        "aria-label",
        "actions",
        "onClose",
        "closeButtonLabel",
        "icon",
        "headline",
        "pretitle",
        "pretitleLinesMax",
        "title",
        "titleAs",
        "titleLinesMax",
        "subtitle",
        "subtitleLinesMax",
        "description",
        "descriptionLinesMax",
        "extra",
        "variant",
        "isInverse",
        "backgroundColor"
    ]);
    const X = r !== void 0, S = t !== void 0, Y = Ve(r), { video: se, videoAction: Z } = Ee(t, i, n), { text: le, ref: ce } = A(), { text: ee, ref: G } = A();
    S && (c = Z ? [
        Z
    ] : []);
    const F = Oe(), j = X || S, L = j ? "0 0 16px rgba(0,0,0,0.4)" : void 0, ae = (c == null ? void 0 : c.length) || u, { textPresets: me } = K(), re = !!(R.href || R.to || R.onPress), te = O || (w ? "inverse" : "default"), Xe = ()=>z || ({
            default: p.colors.backgroundContainer,
            inverse: F ? p.colors.backgroundContainerBrandOverInverse : p.colors.backgroundBrand,
            alternative: p.colors.backgroundAlternative
        })[te], Fe = X || S ? De : te === "inverse" ? ve : de, Le = h || [
        y,
        le,
        x,
        v,
        N,
        ee
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ l(J, {
        width: o,
        height: s,
        dataAttributes: _object_spread({
            "component-name": "PosterCard"
        }, a),
        ref: I,
        aspectRatio: d,
        className: $,
        "aria-label": re ? void 0 : h,
        children: [
            /* @__PURE__ */ e(be, {
                borderRadius: p.borderRadii.legacyDisplay,
                className: Q,
                width: "100%",
                minHeight: "100%",
                isInverse: X || S || te === "inverse",
                background: X || S ? F ? p.colors.backgroundContainerBrandOverInverse : p.colors.backgroundContainer : Xe(),
                children: /* @__PURE__ */ l(_, _object_spread_props(_object_spread({
                    maybe: !0
                }, R), {
                    className: q,
                    "aria-label": re ? Le : void 0,
                    children: [
                        re && /* @__PURE__ */ e("div", {
                            className: Fe
                        }),
                        /* @__PURE__ */ l("div", {
                            className: Ie,
                            "aria-hidden": re,
                            children: [
                                (X || S) && /* @__PURE__ */ e(ye, {
                                    isInverse: F,
                                    children: /* @__PURE__ */ e("div", {
                                        className: we,
                                        children: S ? se : Y
                                    })
                                }),
                                /* @__PURE__ */ l(P, {
                                    className: Se,
                                    paddingTop: j && !m && !ae && !S ? 0 : {
                                        mobile: m ? 16 : 24,
                                        desktop: 24
                                    },
                                    children: [
                                        m ? /* @__PURE__ */ e("div", {
                                            style: H({
                                                [W.mediaBorderRadius]: p.borderRadii.mediaSmall
                                            }),
                                            children: /* @__PURE__ */ e(P, {
                                                paddingBottom: j ? 0 : 40,
                                                paddingX: {
                                                    mobile: 16,
                                                    desktop: 24
                                                },
                                                children: m
                                            })
                                        }) : /* @__PURE__ */ e(P, {
                                            paddingBottom: ae || S ? j ? 24 : 64 : 0
                                        }),
                                        /* @__PURE__ */ e(P, {
                                            paddingX: {
                                                mobile: 16,
                                                desktop: 24
                                            },
                                            paddingTop: j ? 40 : 0,
                                            paddingBottom: 24,
                                            className: j ? Ae : void 0,
                                            children: /* @__PURE__ */ e(Ge, {
                                                title: y ? /* @__PURE__ */ e(ie, _object_spread_props(_object_spread({}, oe.text4), {
                                                    truncate: B,
                                                    weight: me.cardTitle.weight,
                                                    as: k,
                                                    children: y
                                                })) : void 0,
                                                headline: C,
                                                pretitle: x ? /* @__PURE__ */ e(D, {
                                                    forceMobileSizes: !0,
                                                    truncate: T,
                                                    as: "div",
                                                    regular: !0,
                                                    textShadow: L,
                                                    children: x
                                                }) : void 0,
                                                subtitle: v ? /* @__PURE__ */ e(D, {
                                                    forceMobileSizes: !0,
                                                    truncate: V,
                                                    as: "div",
                                                    regular: !0,
                                                    textShadow: L,
                                                    children: v
                                                }) : void 0,
                                                description: N ? /* @__PURE__ */ e(D, {
                                                    forceMobileSizes: !0,
                                                    truncate: M,
                                                    as: "p",
                                                    regular: !0,
                                                    textShadow: L,
                                                    color: j ? p.colors.textPrimary : p.colors.textSecondary,
                                                    children: N
                                                }) : void 0,
                                                headlineRef: ce,
                                                extra: E,
                                                extraRef: G
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }))
            }),
            /* @__PURE__ */ e(U, {
                onClose: u,
                closeButtonLabel: g,
                actions: c,
                type: X || S ? "media" : te === "inverse" ? "inverse" : "default"
            })
        ]
    });
});
export { ma as CardActionIconButton, fa as CardActionSpinner, U as CardActionsGroup, Ja as DataCard, Ua as DisplayDataCard, Qa as DisplayMediaCard, _a as MediaCard, $a as NakedCard, Ya as PosterCard, qa as SmallNakedCard, Ka as SnapCard, Ee as useVideoWithControls };
